import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b74ab632"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bind-sku-item"
}
const _hoisted_2 = { class: "sku-name line--2" }
const _hoisted_3 = { class: "bind flex-ter" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "sku" }
const _hoisted_6 = { class: "cut-bind" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/un_bind_icon.png",
  alt: ""
}, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "bind-sku-item"
}
const _hoisted_9 = { class: "no-bind flex-center" }

import { t } from '@/plugins/i18n'
import confirmDialog from '@/components/common/ConfirmDialog'
import { ref, computed } from 'vue'
import { unbindAmazonSkuApi } from '@/apis/goods'
import { unbindCrossMallSkuApi } from '@/apis/stock'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: ['item', 'showSku'],
  emits: ['success'],
  setup(__props, { emit: emits }) {

const props = __props
const store = useStore()
const isCrossMall = computed(() => store.getters.isCrossMall)


const showSku = ref(true)
const unBindSku = () => {
  confirmDialog({
    title: t('提示'),
    text: t('是否解除绑定'),
    htmlNode: true,
    okText: t('确认'),
    cancelText: t('关闭'),
    closeOnClickModal: false
  }).then(() => {
    console.log(props.item)
    const api = isCrossMall.value ? unbindCrossMallSkuApi : unbindAmazonSkuApi
    
    api({
      shopProductSkuId: props.item.shopProductSkuId
    }).then((res) => {
      if (res.success) {
        showSku.value = false
        emits('success')
      }
    })
  })
}

return (_ctx: any,_cache: any) => {
  return ((__props.item.amazonMsku || __props.item.crossMallProductSku) && showSku.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(isCrossMall) ? __props.item.crossMallProductTitle : __props.item.amazonProductTitle), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(isCrossMall) ? _unref(t)('已绑定CROSS MALL sku') : _unref(t)('已绑定Amazon sku')) + "：", 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(isCrossMall) ? __props.item.crossMallProductSku : __props.item.amazonMsku), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "flex-center",
              onClick: unBindSku
            }, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_unref(t)('解绑')), 1)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(isCrossMall) ? _unref(t)('当前商品未绑定CROSS MALL sku,请在下方搜索CROSS MALL sku进行绑定') : _unref(t)('当前商品未绑定Amazon sku,请在下方搜索Amazon sku进行绑定')), 1)
      ]))
}
}

})